import { EInvoice } from "./e-invoice";
import { InstanceType } from "./instance-types";

export interface ContractType {
  id: number;
  email: string;
  apiKey: string;
  customer: CustomerType | null;
  customerId: number | null;
  instance: InstanceType | null;
  instanceId: number | null;
  bills: Bill[] | null;
  package: Package;
  packageId: number | null;
  configId: number | null;
  createdDate: Date;
  validUntil: Date;
  config: Config;
  phone: string;
  contractType: number;
  contractTitle: string;
}

export enum ContractEnum {
  TrialRequested,
  TrialExpired,
  PayedExpired,
}

export interface CustomerType {
  id: number;
  username: string;
  companyName: string;
  name: string;
  surname: string;
  email: string;
  phone: string;
  address: string;
  pib: string;
  mb: string;
  createdAt: string;
  updatedAt: string;
  apiKey?: string;
  indirectBudgetUserNote: string;
}

export interface Bill {
  id: number;
  filepath: string;
  startDate: Date;
  endDate: Date;
  createdDate: Date;
  updatedDate: Date;
  status: BillStatus;
  price: number;
  contractId?: number;
  contractName?: string;
  exchangeRate?: number;
  isSent: boolean;
  currencyCode: string;
  useIBAN: boolean;
  eInvoiceId?: number;
  eInvoice?: EInvoice;
}
export enum BillStatus {
  Paid = 0,
  Unpaid = 1,
}

export interface BillingInfo {
  companyAddress: string;
  companyEmail: string;
  companyPhone: string;
  accountNumber: string;
  pib: string;
  mb: string;
  iban: string;
  swift: string;
}

export interface RepositoryTagInfo {
  repository: string;
  tag?: string;
  lastPushedDate?: string;
  message?: string;
}

export interface Config {
  id: number;
  AllowedOrigins: string;
  instanceApiConnectionString: string;
  AuthSecret: string;
  AuthApiKey: string;
  AuthBaseUrl: string;
  ETouristBaseUrl: string;
  AdminName: string;
  AdminSurname: string;
  isApplied: boolean;
}

export interface CreatingConfig {
  eTouristBaseUrl: string;
  adminName: string;
  adminSurname: string;
}

export interface Package {
  id: number;
  title: string;
  description: string;
  monthlyPrice: number;
  salesEntriesQuantityCap: number | null;
  eTuristEntriesQuantityCap: number | null;
  branchesQuantityCap: number | null;
  agentQuantityCap: number | null;
  passengersDatabase: boolean;
  servicesDatabase: boolean;
  statisticsDatabase: boolean;
  sendingOfAnnouncementDocuments: boolean;
  creationOfDailySalesOrders: boolean;
  creationOfDailySummaries: boolean;
  organizersHotelsCommunication: boolean;
  travelersCommunication: boolean;
  subAgentsCommunication: boolean;
  eTouristAccounting: boolean;
  statisticsAccounting: boolean;
  calendarAccounting: boolean;
  customerSupport: boolean;
  savaInsurance: boolean;
  eFiskal: boolean;
  openEnded: boolean;
  smsMessaging: boolean;
  enableTravels: boolean;
  enableTickets: boolean;
  enableGroupTravels: boolean;
  enableTransfers: boolean;
  enableOtherServices: boolean;
  enablePackageArrangements: boolean;
  enableTours: boolean;
  onlineApplications: boolean;
  referencePackage: Package | null;
  referencePackageId: number;
}

export interface PackageToUpdate {
  title: string;
  description: string;
  monthlyPrice: number;
  salesEntriesQuantityCap: number | null;
  eTuristEntriesQuantityCap: number | null;
  branchesQuantityCap: number | null;
  agentQuantityCap: number | null;
  passengersDatabase: boolean;
  servicesDatabase: boolean;
  statisticsDatabase: boolean;
  sendingOfAnnouncementDocuments: boolean;
  creationOfDailySalesOrders: boolean;
  creationOfDailySummaries: boolean;
  organizersHotelsCommunication: boolean;
  travelersCommunication: boolean;
  subAgentsCommunication: boolean;
  eTouristAccounting: boolean;
  statisticsAccounting: boolean;
  calendarAccounting: boolean;
  customerSupport: boolean;
  savaInsurance: boolean;
  eFiskal: boolean;
  smsMessaging: boolean;
  enableTravels: boolean;
  enableTickets: boolean;
  enableGroupTravels: boolean;
  enableTransfers: boolean;
  enableOtherServices: boolean;
  enablePackageArrangements: boolean;
  enableTours: boolean;
  onlineApplications: boolean;
  referencePackageId: number;
}
